import React, { useContext } from 'react';
import style from './style.module.scss';
import cn from 'classnames';

import { CommentsContext } from '../../../context/CommentsContext';

function Emoji() {
  const { emojiBoxActive, setEmojiBoxActive, setInput } = useContext(CommentsContext);
  const emojis = [
    '😀',
    '😄',
    '😁',
    '😆',
    '😅',
    '😂',
    '🤣',
    '😊',
    '🙂',
    '🙃',
    '😉',
    '😌',
    '😍',
    '🥰',
    '😘',
    '😋',
    '😜',
    '🤪',
    '🤨',
    '🧐',
    '😎',
    '🤩',
    '🥳',
    '😏',
    '😒',
    '😞',
    '😔',
    '😟',
    '🥺',
    '😢',
    '😭',
    '😠',
    '😡',
    '🤬',
    '🤯',
    '😳',
    '😱',
    '😨',
    '🤗',
    '🤔',
    '🤭',
    '😬',
    '🙄',
    '😯',
    '🤠',
    '😷',
    '🤒',
    '🤡',
    '❤️',
    '💔',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🖤',
    '🤍',
    '🤎',
  ];

  function handleClick(e) {
    setInput(val => val + e.target.textContent);
  }

  return (
    <>
      <div className={cn(style.emojiBox, { [style.active]: emojiBoxActive })}>
        {emojis.map(emoji => (
          <span
            key={emoji}
            className={style.emoji}
            onClick={handleClick}
          >
            {emoji}
          </span>
        ))}
      </div>
      <span
        className={style.iconTrigger}
        onClick={e => setEmojiBoxActive(val => !val)}
      ></span>
    </>
  );
}

export default Emoji;
